import { SimulationCalculationInfoRes } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 労務山積計算-情報取得API
 */
export class WorkYamadumiCalculationInfoGateway {
  static getWorkYamadumiCalculationInfoList = async (
    simulationYm: string,
    procurementNo: string,
    subNo: string,
    branchCd: string,
    expense: string,
    expenseSeq: string
  ) => {
    return await yamadumiApi.get<SimulationCalculationInfoRes>(
      '/api/simulation/calculation-info',
      { simulationYm, procurementNo, subNo, branchCd, expense, expenseSeq }
    )
  }
}
